import { Chip } from '@mui/material';

export const HR_LEAVE_APPLICATION_TABLE_HEAD = () => {
  const getStatusColor = (status) => {
    if (status === 'Leave Approved' || status === 'Approved') {
      return 'success';
    } else if (status === 'Leave Rejected' || status === 'Rejected') {
      return 'error';
    } else if (status === 'Leave Pending' || status === 'Pending') {
      return 'warning';
    }
    return 'default';
  };

  return [
    {
      field: 'sl_no',
      flex: 0.06,
      width: 70,
      headerName: 'S.No',
      type: 'number',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'name',
      flex: 0.15,
      width: 200,
      headerName: 'Employee Name',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'leaveType',
      flex: 0.12,
      width: 200,
      headerName: 'Leave Type',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'fromDate',
      flex: 0.1,
      width: 100,
      headerName: 'From Date',
      type: 'string',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'toDate',
      flex: 0.1,
      width: 100,
      headerName: 'To Date',
      type: 'string',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'noOfdays',
      flex: 0.08,
      width: 80,
      headerName: 'Days',
      type: 'number',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'reason',
      flex: 0.12,
      width: 200,
      headerName: 'Reason',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'appliedOn',
      flex: 0.11,
      width: 200,
      headerName: 'Applied On',
      type: 'string',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'leaveStatus',
      flex: 0.13,
      width: 300,
      headerName: 'Status',
      type: 'string',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <Chip
          label={params.row.leaveStatus}
          color={getStatusColor(params.row.leaveStatus)}
          variant="outlined"
          size="small"
        />
      ),
    },
    {
      field: 'hodRemarks',
      flex: 0.14,
      width: 250,
      headerName: 'Head Remarks',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'hodLastUpdate',
      flex: 0.14,
      width: 200,
      headerName: 'Updated By Head',
      type: 'string',
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'reportingHead',
      flex: 0.12,
      width: 200,
      headerName: 'Head Name',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'hrRemarks',
      flex: 0.14,
      width: 200,
      headerName: 'HR Remarks',
      type: 'string',
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'hrLastUpdate',
      flex: 0.14,
      width: 200,
      headerName: 'Updated By HR',
      type: 'string',
      headerAlign: 'center',
      align: 'center',
    },
  ];
};
